import { storage_keys } from '@/constant/configs';
import { useUserStore } from '@/stores/cutomer/user';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { removeCustomerAuthCreds } from '@/lib/utils/functions';

export default function useAuth() {
  const [isCustomerLoggedIn, setIsCustomerLoggedIn] = useState<boolean>(false);
  const removeUser = useUserStore((state) => state.removeUser);

  const customerToken =
    typeof window === 'undefined'
      ? null
      : window.localStorage.getItem(storage_keys.customer_token);

  useEffect(() => {
    if (customerToken) {
      setIsCustomerLoggedIn(true);
    }
  }, [customerToken]);

  const logOut = (cb?: () => void) => {
    removeCustomerAuthCreds();
    localStorage.removeItem('4TA_CART');
    removeUser();
    if (cb) {
      cb();
    }
    window.location.href = '/';
  };

  return { isCustomerLoggedIn, logOut };
}
